import { Injectable } from "@angular/core";

export interface SubscriptionPackage{
    id:string;
    name:string;
    description:string;
    position:number;
    category:SubscriptionPackageCategory;
    prices:SubscriptionPackagePrice[];
    features:SubscriptionPackageFeature[];
}

export interface SubscriptionPackageCategory{
  id:string;
  name:string;
  min:number;
  max:number;
  position:number;
  prices:SubscriptionPackagePrice[];
}

export interface SubscriptionPackageFeature{
    id:string;
    name:string;
    description?:string;
    systemKey:string;
    limit:number;
    type:"request"|"month"|"limit"|null;
    category:{id:string;name:string}|null;
    new:boolean;
    active?:boolean;
}

export interface GroupedFeatures {
    category: { id: string; name: string } | null;
    features: SubscriptionPackageFeature[];
}


export function groupByCategory(
    features: SubscriptionPackageFeature[]
): GroupedFeatures[] {

    const map = new Map<string | null, GroupedFeatures>();

    for (const feature of features) {
        const key = feature.category ? feature.category.id : null;

        if (!map.has(key)) {
            map.set(key, {
                category: feature.category,
                features: []
            });
        }

        map.get(key)!.features.push(feature);
    }

    return Array.from(map.values());
}

export interface SubscriptionPackagePrice{
    id:string;
    name:string;
    price:number;
    onRequest:boolean;
}

@Injectable({
    providedIn: 'root'
  })
  
  export class SubscriptionPackageAdapter{
    
    adapt(item: any): SubscriptionPackage {
      return {
        id: item.id,
        name:item.name??'',
        description:item.descriptionTranslation??'',
        position:item.position??0,
        category:{ id:'', max:0,min:0, name:'', prices:[], position:0} as SubscriptionPackageCategory,
        prices:[],
        features: item.packageFeatures.map((f:any) => {
          return { id: f.feature.id, name: f.feature.translationKey	, systemKey:f.feature.systemKey, limit: f.limitValue, type:f.featureContext }})
      } as SubscriptionPackage
    }
  }